/* eslint-disable jsx-a11y/anchor-has-content */
import { defaultBikeFleetQuery } from "features/bikeFleet/constant"
import { hasBikeIntoBikeFleetSelector } from "features/bikeFleet/slice/bikeFleetSelector"
import { getLabelFromStatusNumber } from "features/bikeFleet/utils"
import { useCurrentSearchParams } from "hooks/useCurrentSearchParams"
import { useMemo } from "react"
import { Trans, useTranslation } from "react-i18next"
import { useAppSelector } from "store/hooks"
import { FAQLinks } from "utils/constants"
import { FRENCH_CODE } from "utils/i18n"

type NoBikeFleetProps = {
	hasNotBikeFleetIntoStatus: boolean
}
const NoBikeFleet: React.FC<NoBikeFleetProps> = ({ hasNotBikeFleetIntoStatus }) => {
	const hasBikeIntoBikeFleet = useAppSelector(hasBikeIntoBikeFleetSelector)
	const [{ status }] = useCurrentSearchParams(defaultBikeFleetQuery)
	const { t, i18n } = useTranslation()
	const currentLanguage = i18n.language

	const urlFAQ: string = useMemo(() => {
		return currentLanguage.toUpperCase() === FRENCH_CODE.toUpperCase()
			? FAQLinks.FR
			: FAQLinks.EN
	}, [currentLanguage])

	if (!hasBikeIntoBikeFleet) {
		return (
			<div className="w-full  flex flex-col gap-12 p-8">
				<div className="w-full text-center">
					{t("bikeFleet.noBikeInToBikeFleet.sentenceNoBike", { ns: "bike" })}
				</div>
				<div className="w-full text-center max-w-[66.67%] m-auto">
					<div>
						{t("bikeFleet.noBikeInToBikeFleet.NoBikeParagraphOne", { ns: "bike" })}
					</div>
					<div>
						{t("bikeFleet.noBikeInToBikeFleet.NoBikeParagraphTwo", { ns: "bike" })}
					</div>
				</div>
				<div className="w-full text-center text-sm">
					<Trans i18nKey="bikeFleet.noBikeInToBikeFleet.faq" ns="bike">
						Pour plus d’informations
						<a className="underline" target="_blank" href={urlFAQ} rel="noreferrer">
							accédez à la F.A.Q.
						</a>
					</Trans>
				</div>
			</div>
		)
	} else if (hasNotBikeFleetIntoStatus) {
		return (
			<div className="text-center font-bold w-full p-8">
				{t("bikeFleet.noResult", {
					ns: "bike",
				})}
			</div>
		)
	} else return null
}

export default NoBikeFleet
